import { Component } from '@angular/core';

@Component({
  selector: 'app-cards3-examples-15',
  templateUrl: './cards3-examples-15.component.html'
})
export class Cards3Examples15Component {}
